type MembershipConfig = {
  routes_range: { [key: number]: number };
  flight_range: { [key: number]: number };
  route_calendar_range: { [key: number]: number };
};

export const FREE_MEGA_PROGRAMS = 2;
export const MAX_MEGA_PROGRAMS = 6;
export const MAX_MEGA_FLIGHT_RANGE = 35;
export const PRO_ALERT_LIMIT = 70;
export const MAX_FLIGHT_RANGE = 32;
export const FREE_FLIGHT_RANGE = 4;

export const FREE_PANORAMA_RANGE = 90;
export const OPEN_ALL_EXPLORE_DATA = true;

export const DEFAULT_PANORAMA_SEARCH_DAYS = 7;
export const FREE_PANORAMA_SEARCH_DAYS = 30;
export const MAX_PANORAMA_SEARCH_DAYS = 90;

export const DEFAULT_DEALS_FLIGHT_SEARCH_DAYS = 15;
export const MAX_DEALS_FLIGHT_SEARCH_DAYS = 365;

export const MEMBERSHIP_CONFIG: MembershipConfig = {
  routes_range: { 0: FREE_PANORAMA_SEARCH_DAYS, 1: MAX_PANORAMA_SEARCH_DAYS },
  flight_range: { 0: FREE_FLIGHT_RANGE, 1: MAX_FLIGHT_RANGE },
  route_calendar_range: { 0: FREE_PANORAMA_RANGE, 1: 365 },
};

export const YEARLY_MEMBERSHIP_PRICE = 94.99;
export const MONTHLY_MEMBERSHIP_PRICE = 9.99;

export const SHOW_BANNER_CARD = false;

export const PARTIAL_DISPLAY_ITEM_NUM = 2;
